import { FC } from 'react'
import cn from 'classnames'
import classes from './VkUnreadCountBadge.module.css'

export type VkUnreadCountBadgePlacement =
  | 'launcher'
  | 'chatsList'
  | 'picker'
  | 'inline'

type VkUnreadCountBadgeProps = {
  label: string
  placement: VkUnreadCountBadgePlacement
  dock?: boolean
  /** «Мои» — другой цвет, чтобы отличить от «Все» */
  variant?: 'all' | 'mine'
  className?: string
  'aria-label'?: string
  'aria-hidden'?: boolean
}

const VkUnreadCountBadge: FC<VkUnreadCountBadgeProps> = ({
  label,
  placement,
  dock = false,
  variant = 'all',
  className,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <span
    className={cn(
      classes.badge,
      placement === 'launcher' && classes.badge_launcher,
      placement === 'chatsList' && classes.badge_chatsList,
      placement === 'picker' && classes.badge_picker,
      placement === 'inline' && classes.badge_inline,
      dock && classes.badge_dock,
      variant === 'mine' && classes.badge_mine,
      className,
    )}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden}
  >
    <span className={classes.label}>{label}</span>
  </span>
)

export default VkUnreadCountBadge
